"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("homeAnnonceNouvelleVersion", function () {
  return {
    restrict: "E",
    replace: true,
    template: require("./homeAnnonceNouvelleVersion.html"),
    controller: function controller($scope, abonnementAlerteService, $notifications) {
      // changer le nom a chaque nouvelle version
      $scope.taelVersion = "2026.3";
      var cookieName = "tl-annonce-v" + $scope.taelVersion;
      $scope.params = {};
      abonnementAlerteService.getAlerteNouvelleVersion().then(function (data) {
        $scope.params.alerteMailMaj = data;
      });
      $scope.show = $.cookie(cookieName) !== "true";
      $scope.close = function () {
        $scope.show = false;
        $.cookie(cookieName, "true");
      };
      $scope.changeAlerteMail = function () {
        abonnementAlerteService.setAlerteNouvelleVersion($scope.params.alerteMailMaj).then(function (data) {
          $notifications.info($scope.params.alerteMailMaj ? "Notification mail activée" : "Notification mail désactivée");
        });
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/home/annonceNouvelleVersion/homeAnnonceNouvelleVersion.js
// module id = 2785
// module chunks = 13